import type { JSX } from 'react'

export const ActivityIcon = ({ filled }: { filled?: boolean }): JSX.Element => (
  <>
    <use
      href='#activitySolidIcon'
      height='100%'
      width='100%'
      fillOpacity={!filled ? 0 : 1}
    />
    <use
      href='#activityIcon'
      height='100%'
      width='100%'
      fillOpacity={filled ? 0 : 1}
    />
  </>
)
